import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface IStickyActionBarProps {
  onReset: () => void;
  onSave: () => void;
  saving?: boolean;
  saveDisabled?: boolean;
  resetDisabled?: boolean;
  saveLabel?: string;
  // Optional left-aligned content (e.g. validation hints).
  leftSlot?: React.ReactNode;
}

// Shared footer bar for the 3 bot config tabs (Book Demo, Settings, Human Handoff).
// Rendered as a shrink-0 sibling outside the tab's own scrollable content area so it
// is always visible regardless of content height.
const StickyActionBar: React.FC<IStickyActionBarProps> = ({
  onReset, onSave, saving, saveDisabled, resetDisabled, saveLabel = 'Save', leftSlot,
}) => (
  <div className="shrink-0 flex flex-col gap-3 border-t border-gray-200 bg-white/95 px-6 py-4 backdrop-blur sm:flex-row sm:items-center sm:justify-end">
    {leftSlot && <div className="min-w-0 sm:mr-auto">{leftSlot}</div>}
    <div className="flex items-center justify-end gap-3">
      <Button
        type="button"
        variant="outline"
        onClick={onReset}
        disabled={resetDisabled}
      >
        Reset
      </Button>
      <Button
        type="button"
        onClick={onSave}
        disabled={saveDisabled}
        className="min-w-[120px]"
      >
        {saving ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Saving...
          </>
        ) : (
          saveLabel
        )}
      </Button>
    </div>
  </div>
);

export default StickyActionBar;
